export interface PgLaunchTarget {
  gameId?: number;
  isLobby?: boolean;
  isTournament?: boolean;
}

export function buildPgLaunchUrl(game: PgLaunchTarget, groupId?: number): string {
  const params = new URLSearchParams();
  if (groupId) params.set('group_id', String(groupId));

  if (game.isLobby) {
    const qs = params.toString();
    return `/pg-lobby${qs ? '?' + qs : ''}`;
  }

  if (game.isTournament) {
    const qs = params.toString();
    return `/pg-tournament${qs ? '?' + qs : ''}`;
  }

  if (game.gameId) {
    params.set('game_id', String(game.gameId));
  }
  const qs = params.toString();
  return `/pg-launcher${qs ? '?' + qs : ''}`;
}
